// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as V3RevealApi$LiteracyplanetTupperware from "./V3RevealApi.res.mjs";

function PilotClozeDragBucketDisplay(props) {
  var children = props.children;
  var match = Curry._1(V3RevealApi$LiteracyplanetTupperware.use, undefined);
  switch (match.reveal) {
    case "DontHideItems" :
    case "Hide" :
        break;
    case "RevealOneAtATime" :
        return React.createElement("div", {
                    className: "flex gap-4 items-center"
                  }, children);
    
  }
  return React.createElement("div", {
              className: "pilotClozeDragBucketDisplay"
            }, children);
}

var make = PilotClozeDragBucketDisplay;

var $$default = PilotClozeDragBucketDisplay;

export {
  make ,
  $$default as default,
}
/* react Not a pure module */
